<template>
  <!-- Letzten Wareneingang (EK, Kurs, BZNK, Datum) aller Produkte aus dem WMS holen; laeuft sonst nachts per Hangfire -->
  <span v-if="canRefresh" class="last-purchase-refresh">
    <md-button class="md-icon-button md-simple md-dense" :disabled="running" @click="confirmOpen = true">
      <md-icon :class="{ 'last-purchase-refresh--running': running }">sync</md-icon>
      <md-tooltip md-direction="top">{{ $t("lastPurchaseRefresh.button") }}</md-tooltip>
    </md-button>
    <md-dialog-confirm
      class="last-purchase-refresh-dialog"
      :md-active.sync="confirmOpen"
      :md-title="$t('lastPurchaseRefresh.title')"
      :md-content="$t('lastPurchaseRefresh.content')"
      :md-confirm-text="$t('lastPurchaseRefresh.confirm')"
      :md-cancel-text="$t('lastPurchaseRefresh.cancel')"
      @md-confirm="refresh"
    />
  </span>
</template>
<script>
import { hasPermission } from "@/mixins/auth";
import productCalculationService from "@/services/product-calculation.service";

export default {
  name: "LastPurchaseRefresh",
  data() {
    return { confirmOpen: false, running: false };
  },
  computed: {
    canRefresh() {
      return hasPermission("Write", "Products", "Edit") || hasPermission("Write", "Offers", "Edit");
    },
  },
  methods: {
    refresh() {
      this.running = true;
      return productCalculationService
        .refreshLastPurchase()
        .then((updated) => {
          this.$notify({ timeout: 3500, message: this.$t("lastPurchaseRefresh.done", { count: updated }), icon: "add_alert", horizontalAlign: "right", verticalAlign: "top", type: "success" });
          this.$emit("refreshed");
        })
        .catch((e) => {
          if (e && e.response && e.response.status === 403) return;
          this.$notify({ timeout: 3500, message: this.$t("lastPurchaseRefresh.failed"), icon: "add_alert", horizontalAlign: "right", verticalAlign: "top", type: "danger" });
        })
        .finally(() => {
          this.running = false;
        });
    },
  },
};
</script>
<style>
.last-purchase-refresh .md-button.md-icon-button {
  margin: 0 0 0 4px;
  vertical-align: middle;
}
.last-purchase-refresh--running {
  animation: last-purchase-spin 1s linear infinite;
}
@keyframes last-purchase-spin {
  to {
    transform: rotate(-360deg);
  }
}
/* liegt im Produkt-/Angebotsdialog (.modal-mask: 9999) */
.md-dialog.last-purchase-refresh-dialog {
  z-index: 10001;
}
.last-purchase-refresh-dialog .md-dialog-container {
  max-width: 520px;
}
</style>
